<template>
    <div class='customer-response-node'>
        <div class='image'>
            <font-awesome-icon icon='user' />
        </div>
        <div class='info'>
            <p class='strong'>{{ data.business }}</p>
            <p>{{ data.firstname }} {{ data.lastname }}</p>
            <p>{{ data.email }}</p>
            <p>{{ data.number }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    name: 'CustomerResultNode'
}
</script>

<style scoped lang="scss">
.customer-response-node{
    display: flex;
    align-items: center;
    color: rgb(77, 77, 77);
    & .image {
        margin-right: 15px;
        height: 50px;
        width: 50px;
        background-color: rgb(0, 122, 116);
        border-radius: 50%;
        border: 5px solid rgb(93, 212, 206);
        color: #fff;
        font-size: 1.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    & .info {
        display: flex;
        width: calc(100% - 70px);
        flex-wrap: wrap;
        & p {
            word-wrap: break-word;
            width: 50%;
            padding: 0;
            margin: 5px 0;
            &:nth-child(even){
                text-align: right;
            }
        }
    }
}
</style>
